/* eslint-disable @web-monorepo/no-css-file-imports */
import "extended-proptypes/lib/extend-from-standalone";
import "src/stylesheets/normalize.css";
import "src/stylesheets/transitions.css";
import "src/stylesheets/base.css";
import LaunchpadContainer from "src/pods/launchpad/components/LaunchpadContainer";
import HostStateContainer from "src/pods/realtime/components/HostStateContainer";

export default function LaunchpadPage() {
  return (
    <HostStateContainer>
      <LaunchpadContainer />
    </HostStateContainer>
  );
}
